class UsedCarBookmarkList extends CarStorage {
    /**
     * @returns {string}
     */
    storageKey() {
        return 'used-car-bookmark-list';
    }
}
